import React from "react";
import Aboutus from "./About-us";
import Whychooseus from "./Why-choose-us";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Breadcrump from "../Breadcrump/Breadcrump";
function Aboutmain() {
  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    onTop();
  }, [routePath]);
  return (
    <>
    <Header/>
      <div>
        <Helmet>About Us || Arthika jewels</Helmet>
      </div>
      <Breadcrump cont2="About Us" />
      <Aboutus />
      <Whychooseus />
      <Footer/>
    </>
  );
}

export default Aboutmain;
